export default {
  init() {
    var $grid = $('.posts-wrapper').masonry({
      itemSelector: '.grid-item',
      columnWidth: '.grid-sizer',
      percentPosition: true,
      transitionDuration: 0,
    });

    $grid.imagesLoaded().progress( function() {
      $grid.masonry('layout');
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-posts.js